import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../Hooks/useToast";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import DatagridTable from "../Components/Table/DataGrid_Table";
import { createColumn } from "../Components/Table/DataGrid_Cullums";
import AccoCodeModal from "./Reservations/ACC_Code_Modal";
import CellImg from "../Components/Table/Cell_Img";

import { fetchReservationsByGift, fetchReservationsByPayWay } from "../Redux/Reservations_Slice";
import { FetchEditReservations } from "../Apis/Reservations/Reservations";

const GutscheineGeschenke = () => {
  const dispatch = useDispatch();
  const { toastSuccess, toastError } = useToast();
  const { data, isLoading, pagination } = useSelector((state) => state.Reservations);

  const [activeView, setActiveView] = useState("vouchers");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [Loading, setIsLoading] = useState(false);

  useEffect(() => {
    if (activeView === "vouchers") {
      console.log('Fetching gifts with params:', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        isAGift: true
      });
      
      dispatch(
        fetchReservationsByGift({
          page: paginationModel.page + 1,
          limit: paginationModel.pageSize,
          isAGift: true,
        })
      );
    } else {
      dispatch(
        fetchReservationsByPayWay({
          page: paginationModel.page + 1,
          limit: paginationModel.pageSize,
          payWay: "code",
        })
      );
    }
  }, [dispatch, activeView, paginationModel.page, paginationModel.pageSize]);

  const handlePaginationModelChange = (newModel) => {
    setPaginationModel(newModel);
  };

  const handleImageClick = (reservation) => {
    setSelectedReservation(reservation);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedReservation(null);
  };

  const handleAccept = async () => {
    setIsLoading(true);
    try {
      const response = await FetchEditReservations(
        { isPaid: true },
        selectedReservation.id
      );
      if (response.status === 200) {
        toastSuccess(" Der Prozess wurde erfolgreich abgeschlossen!");
        handleCloseModal();
        dispatch(
          fetchReservationsByPayWay({
            page: paginationModel.page + 1,
            limit: paginationModel.pageSize,
            payWay: "code",
          })
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDecline = async () => {
    setIsLoading(true);
      try {
        const response = await FetchEditReservations(
          { isPaid: false },
          selectedReservation.id
        );
        if (response.status === 200) {
          toastSuccess("Der Prozess wurde erfolgreich abgeschlossen!");
          handleCloseModal();
          dispatch(
            fetchReservationsByPayWay({
              page: paginationModel.page + 1,
              limit: paginationModel.pageSize,
              payWay: "code",
            })
          );
        }
      } catch (error) {
        toastError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."); 
      } finally {
        setIsLoading(false);
      }
    };   

  const voucherColumns = [
    createColumn("userName", "Von", 400),
    createColumn("payWay", "Zahlungsart", 400),
    createColumn("nameOfreceiver", "An", 400),
  ];  
  const giftColumns = [
    createColumn("userName", "Kundenname", 400),
    createColumn("status", "Status", 400, "string", ({ value }) => {
          let color, label;
          if (value === "accepted" || value === "Angenommen") {
            color = "#B6E6C1";
            label = "Angenommen";
          } else if (value === "rejected" || value === "Abgelehnt") {
            color = "#E6B6B6";
            label = "Abgelehnt";
          } else {
            color = "#F0E0C0";
            label = "Ausstehend";
          }
          return (
            <span
              style={{
                backgroundColor: color,
                padding: "12px 18px",
                borderRadius: "10px",
                fontWeight: "bold"
              }}
            >
              {label}
            </span>
          );
        }),
    createColumn("codePhoto", "Gutschein", 400, "actions", (params) => (
      <CellImg onClick={() => handleImageClick(params.row)} src={params.value} />
    )),
  ];

  return (
    <Box>
      <Box sx={{ mt: 0.5, mb: 2.5, gap: 3 }}>
        <Button
          sx={{
            border: activeView === "vouchers" ? "solid 2px #D6B981" : "none",
            bgcolor: "white",
            py: 1.2,
            px: 2.5,
            borderRadius: "12px",
            fontSize: "16px",
            color: activeView === "vouchers" ? "#D6B981" : "#A8A8A8",
          }}
          onClick={() => setActiveView("vouchers")}
        >
          Geschenke
        </Button>
        <Button
          sx={{
            border: activeView === "gifts" ? "solid 2px #D6B981" : "none",
            py: 1.2,
            bgcolor: "white",
            px: 2.5,
            ml: 2,
            borderRadius: "12px",
            color: activeView === "gifts" ? "#D6B981" : "#A8A8A8",
            fontSize: "16px",
          }}
          onClick={() => setActiveView("gifts")}
        >
          Gutscheine
        </Button>
      </Box>

      <Box sx={{ height: 600, width: "100%" }}>
        <DatagridTable
          columns={activeView === "vouchers" ? voucherColumns : giftColumns}
          rows={data || []}
          loading={isLoading}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={pagination?.total || 0}
          pageSizeOptions={[5, 10, 25]}
        />
      </Box>

      <AccoCodeModal
        open={openModal}
        onClose={handleCloseModal}
        reservation={selectedReservation}
        onAccept={handleAccept}
        onDecline={handleDecline}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default GutscheineGeschenke;